<template>
    <div class="videos">
        <div :id="'mse_' + index" v-if="videoList">
            <video
                width="100%"
                height="100%"
                style="object-fit:fill"
                webkit-playsinline="true"
                x-webkit-airplay="true"
                playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                preload="auto"
                :src="videoList.url"
                :poster="videoList.poster"
                ref="videos"
            ></video>

            <div class="play_button" v-show="play_show">
                <van-button color="#ff5051" icon="play" type="primary" :round="true" />
            </div>
        </div>
    </div>
</template>
  
<script>

import { Toast } from 'vant';

export default {
    name: 'Videos',
    //子组件接收父组件(VideoList)
    props: ['videoList', 'index', 'cur_index', "isIOS"],
    data() {
        const t_width = document.documentElement.clientWidth > 750 ? 750 : document.documentElement.clientWidth

        return {
            xgpoptions: {
                width: t_width,
                fluid: true,
                height: document.documentElement.clientHeight,
                controls: false,
                playsinline: true,
                'x5-video-player-type': 'h5',
                //"closeVideoTouch": true,

                "keyShortcut": "off",
                'x5-video-orientation': 'portraint',

            },
            player: "",
            playing: true,
            init_count: 0,
            first_flag: false,
            play_show: true,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {


            this.$refs.videos.addEventListener("ended", () => {
                if (this.init_count == 0) {
                    Toast('播放完毕，上滑查看更多推荐视频')
                    this.init_count++
                }
                this.play_show = true;
            })
            this.$refs.videos.addEventListener("play", () => {

                this.play_show = false;
            })
            this.$refs.videos.addEventListener("pause", () => {

                this.play_show = true;
            })

        },
        async playOrStop() {
            if (this.$refs.videos.paused) {
                await this.play();
            } else {
                await this.stop();
            }
        },
        onPlayerEnded() {


        },
        async play() {

            if (this.$refs.videos.paused) {
                await this.$refs.videos.play();
            }
        },
        async stop() {

            if (!this.$refs.videos.paused) {
                await this.$refs.videos.pause();
            }

        },
    },

    watch: {

    }
}
</script>
  
<style>
.play_button {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    transform: translate(-50%, -50%);
}
</style>